import { BadgeProps } from '../base/badge'

export const contactTypes: Record<string, { name: string, color: BadgeProps['color'] }> = {
  crew: { name: 'Crew', color: 'indigo' },
  crew_manager: { name: 'Crew manager', color: 'purple' },
  project_manager: { name: 'Project manager', color: 'green' },
  production_manager: { name: 'Production manager', color: 'orange' },
  site_manager: { name: 'Site manager', color: 'red' },
  safety_manager: { name: 'Safety manager', color: 'yellow' },
  security_manager: { name: 'Security manager', color: 'blue' },
}
